import { Box } from '@chakra-ui/react';
import dayjs from 'dayjs';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { TTransaction } from '@/lib/DBModels';
import { TableText } from '../styles/DesktopTransactionsTable.styles';
import { useWinningsStake } from '@/views/account/Transactions/components/TransactionTable/Services/Transactions.hooks';

export type TSrmDetailsProps = {
  transaction: TTransaction;
};

const POSITION_MAP = {
  Top1: 'Win',
  Top2: 'Top 2',
  Top3: 'Top 3',
  Top4: 'Top 4',
};

export default function SrmDetails({ transaction }: TSrmDetailsProps) {
  const {
    bet_id: betId,
    match_name: matchName,
    match_start_time: matchStartTime,
    bet_odds: betOdds = 0,
    race_number: raceNumber,
    venue_name: venueName,
    leg_details: legDetails = [],
    race_type: raceType,
  } = transaction.details ?? {};
  const winningsStake = useWinningsStake(transaction);

  return (
    <>
      <FormattedMessage
        id="account.transactions.srmTransactionTitle"
        values={{
          legCount: legDetails.length,
          odds: betOdds.toFixed(2),
          hasOdds: !!betOdds,
        }}
      />
      {winningsStake}
      <TableText>{matchName}</TableText>
      <TableText
        sx={{ pb: 2 }}
      >{`${raceType} - ${venueName} - R${raceNumber}`}</TableText>
      <TableText sx={{ pb: 2 }}>
        <FormattedMessage
          id="account.transactions.eventDateTimeWithValue"
          values={{
            value: dayjs(matchStartTime).format('DD/MM/YYYY HH:mm:ss (z)'),
            time: (chunks) => <time dateTime={matchStartTime}>{chunks}</time>,
          }}
        />
      </TableText>
      {legDetails.map(
        (
          {
            proposition_details: { runner_number, runner_name, top_selection },
          },
          matchIndex
        ) => (
          <Box key={matchIndex} sx={{ pb: 2 }}>
            <TableText>
              {runner_number}. {runner_name}
              {' - '}
              {POSITION_MAP[top_selection]}
            </TableText>
          </Box>
        )
      )}
      <TableText sx={{ pt: 2 }}>
        <FormattedMessage
          id="account.transactions.betIdWithValue"
          values={{ value: betId }}
        />
      </TableText>
    </>
  );
}
